// Where did a request handled by the queue originate?
// This information can be sent with a request and will therefore be available in the response object. It can be used to
// manage the display of errors. For example if an error occurs in a request submitted by the queue we probably don't
// want to display it because it may not bear any relation to what is happening on screen at that time.

const OnlineTaskTrigger = Object.freeze({
    OFFLINE: 'offline',
    OFFLINE_RETRY: 'offline_retry',
    ONLINE: 'online',
    ONLINE_RETRY: 'online_retry',
});

module.exports = OnlineTaskTrigger;
